import {
  isActionableAttributeReviewStatus,
  isRejectedAttributeReviewStatus,
} from "./reviewQueueStatus";

type Row = { id?: unknown; decisionStatus?: unknown };
export type LocalStatus = ReadonlyMap<string, string>;

export function afterDecision(d: { decision: string }): string {
  if (d.decision === "APPROVE") return "APPROVED";
  if (d.decision === "IGNORE" || d.decision === "REJECT") return "REJECTED";
  return "PENDING";
}

const kind = (status: unknown) =>
  isActionableAttributeReviewStatus(status)
    ? "open"
    : isRejectedAttributeReviewStatus(status)
      ? "ignored"
      : "done";

export function withLocalStatus<T extends Row>(
  rows: T[],
  local: LocalStatus,
): T[] {
  if (local.size === 0) return rows;
  return rows.map((row) => {
    const status = local.get(String(row.id));
    return status === undefined ? row : { ...row, decisionStatus: status };
  });
}

export const openCount = (rows: Row[]) =>
  rows.filter((row) => isActionableAttributeReviewStatus(row.decisionStatus))
    .length;

export function dropSettled(
  local: LocalStatus,
  serverRows: Row[],
): LocalStatus {
  const server = new Map(
    serverRows.map((row) => [String(row.id), row.decisionStatus]),
  );
  const kept = new Map(
    [...local].filter(
      ([id, status]) =>
        !server.has(id) || kind(server.get(id)) !== kind(status),
    ),
  );
  return kept.size === local.size ? local : kept;
}
